import { AlertType } from "@tandemdiabetes/sugarmate-api-react-client"
import { ActionLink } from "@tandemdiabetes/sugarmate-react-components"
import { Link } from "@tanstack/react-router"
import onboardingStyles from "../Onboarding.module.scss"
import { OnboardingPageTemplate } from "src/components"
import {
  useFollowedUsers,
  usePolyglot,
} from "src/contexts"
import {
  useAlert,
  useDebouncedUpdateAlert,
  usePrimaryPhone,
} from "src/hooks"
import {
  Contacts,
  PhoneNumber,
  SetupHelpLink,
} from "src/pages/Settings/Alerts/Contacts"
import {
  LowGlucoseThreshold,
  LowGlucoseToggle,
  SleepHours,
} from "src/pages/Settings/Alerts/PhoneCallAlerts"

interface Props {
  routePrefix: "/data_sharing/following" | "/onboarding";
  backRoutePath: "/onboarding/ranges"
  | "/onboarding/accept_invite/$accountId/success"
  | "/data_sharing/following/accept_invite/$accountId/success";
}

const polyglotPrefix = "pages.onboarding.phone_call_alerts."

export function PhoneCallAlerts(props: Props) {
  const {
    backRoutePath,
    routePrefix,
  } = props

  const polyglot = usePolyglot()
  const primaryPhone = usePrimaryPhone()
  const belowNormalCall = useAlert(AlertType.BelowNormalCall)

  const {
    currentFollow,
    currentUserId,
  } = useFollowedUsers()

  const debouncedUpdatePartialAlert = useDebouncedUpdateAlert(
    primaryPhone,
    belowNormalCall,
    "phone-alerts-update-error-toast",
  )

  return (
    <OnboardingPageTemplate
      backRoutePath={backRoutePath}
      title={polyglot.t(`${polyglotPrefix}title`)}
    >
      <div className={onboardingStyles.container}>
        {belowNormalCall && (
          <LowGlucoseToggle
            belowNormalCall={belowNormalCall}
            updateAlert={debouncedUpdatePartialAlert}
          />
        )}
        {belowNormalCall?.is_active && (
          <>
            <LowGlucoseThreshold
              belowNormalCall={belowNormalCall}
              updateAlert={debouncedUpdatePartialAlert}
            />
            <SleepHours />
            <PhoneNumber
              primaryPhone={primaryPhone}
              maxPhoneNumbers={1}
              sugarmateAlert={belowNormalCall}
              updateAlert={debouncedUpdatePartialAlert}
            />
            <Contacts
              primaryPhone={primaryPhone}
              sugarmateAlert={belowNormalCall}
            />
            <SetupHelpLink />
          </>
        )}
        <ActionLink
          asChild
          className={onboardingStyles.submitCta}
          stylePreset={belowNormalCall?.is_active ? "primary" : "secondary"}
        >
          <Link
            to={currentFollow.is_self
              ? "/onboarding/theme"
              : `${routePrefix}/accept_invite/$accountId/theme`
            }
            params={currentFollow.is_self ? {} : { accountId: currentUserId }}
            id="next-button"
          >
            {polyglot.t(
              belowNormalCall?.is_active
                ? `${polyglotPrefix}next_cta`
                : `${polyglotPrefix}skip_cta`,
            )}
          </Link>
        </ActionLink>
      </div>
    </OnboardingPageTemplate>
  )
}
